import { render, staticRenderFns } from "./imageTwo.vue?vue&type=template&id=ddca6228&scoped=true&"
import script from "./imageTwo.vue?vue&type=script&lang=js&"
export * from "./imageTwo.vue?vue&type=script&lang=js&"
import style0 from "./imageTwo.vue?vue&type=style&index=0&id=ddca6228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddca6228",
  null
  
)

export default component.exports